export class CompanyTemplateApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createFromTemplateCompany({ testMode, ...body }) {
    return this.#http.post('/Company/from-template', body, { params: { testMode } });
  }
}
